import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { DataList, InfoTooltip } from '@morpho-org/ui-v6/client';
import { memo } from 'react';
import GuardianAddress from '@/components/VaultPage/VaultV1/GuardianAddress/GuardianAddress';
import type { GuardianMetadataItems, VaultPendingTimelocks } from '../TimelockDurationDataLine/types';
import PendingTimelocksIndicator from './PendingTimelocksIndicator';
export interface GuardianDataLineProps {
  chainId: ChainId;
  address?: Address;
  safeQuorum?: string;
  isAragonDAO?: boolean;
  pendingTimelocks: VaultPendingTimelocks;
  currentGuardianMetadata?: GuardianMetadataItems;
}
const GuardianDataLine = t0 => {
  const $ = _c(17);
  const {
    address,
    chainId,
    safeQuorum,
    isAragonDAO,
    pendingTimelocks,
    currentGuardianMetadata
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-secondary-foreground text-xs">Guardian</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-[6px]">{t1}<InfoTooltip tooltipContent={<>Can trigger predefined protective functions such as pausing or restricting certain actions. Acts as a check on the Curator.</>} /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== address || $[3] !== chainId || $[4] !== currentGuardianMetadata || $[5] !== pendingTimelocks) {
    t3 = pendingTimelocks.length > 0 && <PendingTimelocksIndicator chainId={chainId} pendingTimelocks={pendingTimelocks} address={address} currentGuardianMetadata={currentGuardianMetadata} />;
    $[2] = address;
    $[3] = chainId;
    $[4] = currentGuardianMetadata;
    $[5] = pendingTimelocks;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <DataList.LeftItem>{t2}{t3}</DataList.LeftItem>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== address || $[10] !== chainId || $[11] !== isAragonDAO || $[12] !== safeQuorum) {
    t5 = <DataList.RightItem><GuardianAddress chainId={chainId} address={address} isAragonDAO={isAragonDAO} safeQuorum={safeQuorum} /></DataList.RightItem>;
    $[9] = address;
    $[10] = chainId;
    $[11] = isAragonDAO;
    $[12] = safeQuorum;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <DataList.Line>{t4}{t5}</DataList.Line>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default memo(GuardianDataLine);